<script>
  export let message
  export let style
  export let className = ''
</script>

<div on:click class={className} {style}>
  {@html message}
</div>
